
/**
 * This class holds synchronization-event-types.
 */

export class SyncEventType {

  // Realtime Events
  //
  public static readonly ISSUECARD_OPENED = 'sync-issuecard-opened';
  public static readonly ISSUECARD_CLOSED = 'sync-issuecard-closed';
  public static readonly ISSUECARD_TO_FOREGROUND = 'sync-issuecard-to-foreground';
  public static readonly ISSUECARD_MOVED = 'sync-issuecard-moved';
  public static readonly ISSUECARD_DISCARDED = 'sync-issuecard-discarded';
  public static readonly ISSUECARD_UPDATED = 'sync-issuecard-updated';
  public static readonly ISSUECARD_UPDATED_EXT = 'sync-issuecard-updated-extended-data';
  public static readonly ISSUECARD_CREATE_CANCELED = 'sync-issuecard-create-new-issue-canceled';

  public static readonly SPRINTCARD_OPENED = 'sync-sprintcard-opened';
  public static readonly SPRINTCARD_CLOSED = 'sync-sprintcard-closed';
  public static readonly SPRINTCARD_MOVED = 'sync-sprintcard-moved';
  public static readonly SPRINTECARD_TO_FOREGROUND = 'sync-sprintcard-to-foreground';

  public static readonly WIDGET_TEAM_HIGHTLIGHT_CHANGED = 'widget-team-highlight-changed';
  public static readonly USERLOGGEDOUT = 'sync-user-loggedout';

  // Persistence-Events
  //
  public static readonly ISSUE_OPENED = 'sync-pers-issuecard-opened';
  public static readonly ISSUE_CLOSED = 'sync-pers-issuecard-closed';
  public static readonly ISSUECARD_FOCUS = 'sync-issuecard-focus';
  public static readonly ISSUE_CREATED = 'sync-issue-created';
  public static readonly ISSUE_UPDATED = 'sync-issue-updated';
  public static readonly ISSUE_DELETED = 'sync-issue-deleted';
  public static readonly SPRINT_CREATED = 'sync-sprint-created';
  public static readonly SPRINT_UPDATED = 'sync-sprint-updated';
  public static readonly SPRINT_DELETED = 'sync-sprint-deleted';
  public static readonly USER_LOGGEDIN = 'sync-pers-user-loggedin';
  public static readonly PROJECT_UPDATED = 'sync-pers-project-updated';
  public static readonly ALL_ISSUES_MARKED_AS_READ = 'sync-all-issues-marked-as-read';

  public static readonly COPILOT_MEETING_ANALYSIS_ID = 'sync-copilot-meeting-outcomes-id';
  // WebRTC
  //
  public static readonly WEBRTC_GOT_USER_MEDIA = 'got user media';

  // Board MPC
  public static readonly MPC_SPRINT_ADD_ISSUE = 'sync-mpc-sprint-add-issue';
  public static readonly MPC_SPRINT_REMOVE_ISSUE = 'sync-mpc-sprint-remove-issue';


  // Chat Events
  //
  public static readonly MESSAGE_CREATED = 'chat-message-created';
  public static readonly AI_ISSUE_SUGGESTION_CREATED = 'ai-issue-suggestion-created';
  public static readonly AI_ISSUE_SUGGESTION_EDITED = 'ai-issue-suggestion-edited';
  public static readonly ACTION_ITEM_ISSUE_UPDATED = 'action-item-issue-updated';
  public static readonly AI_STATE_CHANGED = 'ai-state-changed';


  // Copilot
  public static readonly COPILOT_SESSION_ID = 'sync-copilot-session-id';
}
